import React from "react";

import { useTranslation } from "react-i18next";

import AdBreakForm from "./AdBreakForm";
import { MEDIA_FORMATS } from "../../../constants/media";
import Collapsed from "../../common/tools/Collapsed";
import MediaLibrary from "../mediaLibrary/MediaLibrary";

import type { JSX } from "react";

export default function AdBreaksEdit(): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");

  return (
    <React.Fragment>
      <div className="sticky top-0 mr-[0.78125rem] flex">
        <Collapsed title={t("programs_inventory")}>
          <MediaLibrary
            defaultFormatFilter={{
              includes: [
                MEDIA_FORMATS.ADPOD,
                MEDIA_FORMATS.BUMPER,
                MEDIA_FORMATS.PROMOTION,
              ],
            }}
          />
        </Collapsed>
      </div>
      <div className="grow">
        <AdBreakForm />
      </div>
    </React.Fragment>
  );
}
